<template>
  <v-card class="create-a-sor">
    <v-card-title class="justify-center">
      {{ $t('work_order.edit_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('work_order.contract_year') }}
          </v-col>
          <v-col cols="9">
            <v-select outlined
                      :items="contractYearOptions"
                      v-model="contractYear"
                      :rules="requiredRules"></v-select>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('work_order.work_order_no') }}
          </v-col>
          <v-col cols="9">
            <v-text-field outlined
                          v-model="work_order_no"
                          :rules="requiredRules"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('work_order.name') }}
          </v-col>
          <v-col cols="9">
            <v-text-field outlined
                          v-model="name"
                          :rules="requiredRules"></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && confirm()"
             depressed
             large>
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";

export default {
  name: 'EditWorkOrderDialog',
  props: {
    workOrder: Object,
    contractId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required'),
    ]);

    const contractYears = ref([]);
    const getContractYears = async function () {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/year/',
        params: {
          contract_id: props.contractId,
        },
      });

      if (response.body.success) {
        contractYears.value = response.body.years;
      }
    }
    const contractYearOptions = computed(() => {
      return contractYears.value.map((y) => y.year);
    })
    const contractYear = ref(null);
    const work_order_no = ref(null);
    const name = ref('');

    const confirm = async function () {
      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/contract/work_order/edit/',
        params: {
          work_order_id: props.workOrder.id,
          work_order_no: work_order_no.value,
          contract_year: contractYear.value,
          name: name.value,
        },
      });

      if (response.body.success) {
        emit('submit', response.body.work_order.id)
      }
    }

    onMounted(() => {
      getContractYears();

      contractYear.value = props.workOrder.contract_year.year;
      work_order_no.value = props.workOrder.work_order_no;
      name.value = props.workOrder.name;
    })

    return {
      requiredRules,

      contractYearOptions,
      contractYear,
      work_order_no,
      name,

      confirm,
    }
  },
}
</script>

<style lang="less">
.create-a-sor {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }

  .step-1-wrapper {
    flex: 1 0 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
